// REUN-02: a tension is proposable in the meeting "attach a tension" picker
// only if its circle sits in the intersection of the meeting's scope (its own
// circle plus direct children, from e834b3cc) and the circles the current
// member participates in. Representation is kept as-is (the caller passes
// OrgData.getParticipantCircles, which climbs to the parent circle and, for a
// link role, the grandparent): Yocoop's container circles have no direct
// members, only child roles, so requiring a direct membership would make a
// circle's own tensions unreachable from that circle's own meeting.
export function getPickerCirclesIds(
  meetingCircleId: string | undefined,
  childrenIds: string[],
  participantCirclesIds: string[]
): string[] {
  if (!meetingCircleId || participantCirclesIds.length === 0) return []

  // scopeIds never has duplicates on its own (a circle is never its own
  // child), so a Set on participantCirclesIds is enough to absorb any
  // duplicate the caller passes there — no output-side dedup needed.
  const participantIds = new Set(participantCirclesIds)
  const scopeIds = [meetingCircleId, ...childrenIds]

  return scopeIds.filter((id) => participantIds.has(id))
}
